import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import ru from './ru.json';
import tr from './tr.json';
import pl from './pl.json';

const translations = { de, en, fr, it, nl, ru, tr, pl };

export function getTranslation(lang) {
  return translations[lang] || translations.en;
}

export function detectLanguage() {
  const saved = localStorage.getItem('rpm_lang');
  if (saved && translations[saved]) return saved;
  const browserLang = navigator.language?.substring(0, 2);
  return translations[browserLang] ? browserLang : 'en';
}

export const availableLanguages = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'pl', label: 'Polski' },
  { code: 'ru', label: 'Русский' },
  { code: 'tr', label: 'Türkçe' },
];
